// extracted by mini-css-extract-plugin
export default {"base":"ActionEdited_base__yChVC"};